import { render, staticRenderFns } from "./pageFoot.vue?vue&type=template&id=8741f466&scoped=true&"
import script from "./pageFoot.vue?vue&type=script&lang=js&"
export * from "./pageFoot.vue?vue&type=script&lang=js&"
import style0 from "./pageFoot.vue?vue&type=style&index=0&id=8741f466&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8741f466",
  null
  
)

export default component.exports